import { HBO_COMMUNICATION_PATH } from '../constants';
import { claimHboCommunicationIntent } from './hboCommunicationIntent';

// Punto unico para los redireccionamientos posteriores al login / seleccion de perfil: si el
// usuario entro por /activacionhbo sin sesion, se le lleva directo a esa ruta en lugar de a
// Home (evita el parpadeo de Home). Devuelve la ruta fija o null si el flujo sigue normal.
// La intencion se conserva durante la ventana de asentamiento para que un segundo
// redireccionamiento del mismo login/perfil tambien termine en /activacionhbo.
// Con `profileSelectionPending` (el selector de perfil aun se mostrara) devuelve null SIN
// consumir la intencion: el usuario no debe saltarse la eleccion de perfil, y el
// redireccionamiento posterior a elegirlo la usara.
export const getHboCommunicationPostLoginPath = ({ profileSelectionPending = false } = {}) => {
  if (profileSelectionPending) return null;

  return claimHboCommunicationIntent() ? HBO_COMMUNICATION_PATH : null;
};